import React, { useState } from "react";
import type { ChemicalType } from "../../types";
import { MESSAGES } from "../../constants/const";
import { showErrorMessage } from "../appPane";
import InputText from "../inputText";
import ModalHeader from "./modalHeader";

interface Props {
  /** 薬剤カテゴリ情報 */
  type?: ChemicalType;
  /** キャンセルボタンハンドラ */
  onClose: () => void;
  /** 登録ボタンハンドラ */
  onRegister: (type: ChemicalType) => void;
}

/**
 * 薬剤カテゴリ編集ポップアップ
 * @param props
 * @returns
 */
export const ChemicalTypeModal: React.FC<Props> = ({ type, onClose, onRegister }) => {
  const [name, setName] = useState(type?.chemicalTypeName ?? "");

  // フォーム送信
  const sendForm = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!name || name === "") {
      showErrorMessage(MESSAGES.ERROR_INPUT_EMPTY);
      return;
    }

    const data: ChemicalType = {
      chemicalTypeId: type?.chemicalTypeId,
      chemicalTypeName: name,
    };
    onRegister(data);
  };

  return (
    <div className="modal">
      <div className="content">
        <ModalHeader title="薬剤カテゴリ" onClose={onClose} />
        <form onSubmit={sendForm}>
          <div className="parts">
            <label>薬剤カテゴリ名：</label>
            <InputText val={name} onChange={setName} />
          </div>

          <div className="parts actions">
            <button type="button" onClick={onClose} className="negative">
              キャンセル
            </button>
            <button type="submit" className="positive">
              登録
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default ChemicalTypeModal;
